import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import DataGridCell from './DataGridCell';
import { IsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';

export function adminCell<T>(params: GridRenderCellParams<T>) {
  return (
    <IsTenantAdministrator>
      <DataGridCell content={params.value as string} />
    </IsTenantAdministrator>
  );
}
